// extracted by mini-css-extract-plugin
export default {"input":"CheckboxButton_input__Jwr7+","label":"CheckboxButton_label__74qWh","checkbox":"CheckboxButton_checkbox__Bgpas"};